import { TrelloWindow } from '@trello/window-types';

import { forNamespace } from './forNamespace';
import { AllSubstitutions } from './babble';

declare const window: TrelloWindow;

export const localizeCount = (
  name: string,
  count: number,
  substitutions: AllSubstitutions = {},
) => {
  const formatCounts = forNamespace('counts');

  const { counting = (value: number) => value } = window.__locale ?? {};

  return formatCounts([name, counting(count)], {
    count: `${count}`,
    ...substitutions,
  });
};
